module.exports = __webpack_public_path__ + "static/img/guanggao2.df368a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school/guanggao2.png
// module id = 6mMx
// module chunks = 3